// Generated by ReScript, PLEASE EDIT WITH CARE


function execute(customer) {
  return {
          customer: {
            mobile: customer.mobile,
            first_name: customer.first_name,
            last_name: customer.last_name,
            geo_region_id: customer.geo_region_id,
            frequency: customer.frequency
          }
        };
}

export {
  execute ,
  
}
/* No side effect */
